/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 02/06/2020
 *
 */

import React from 'react';
import './card.css';

/** functional component for CardIcon **/
const CardIcon = (props) => {
    const {children, icon, ...rest} = props;

    let iconClass;

    switch (icon) {
        case 'user':
            iconClass = 'fa fa-user-secret';
            break;
        case 'log':
            iconClass = 'fa fa-user-md';
            break;
        default:
            iconClass = 'fa fa-home';
    }
    return (
        <div className="cardIcon" {...rest}>
            <i className={iconClass} />
        </div>
    )
};

export default CardIcon;
